import { createFileRoute } from "@tanstack/react-router";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../../Components/ui/Form";
import { forgetPasswordSchema } from "../../Types/UserTypes";
import type { ForgetPassword } from "../../Types/UserTypes";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Input } from "../../Components/ui/Input";
import { Button } from "../../Components/ui/Button";
import { requestPasswordReset } from "../../lib/PB/Users";

export const Route = createFileRoute("/Auth/ForgetPassword")({
  component: ForgetPassword,
});

export default function ForgetPassword() {
  const form = useForm<ForgetPassword>({
    resolver: zodResolver(forgetPasswordSchema),
  });
  const onSubmit = async (values: ForgetPassword) => {
    requestPasswordReset(values.email);
    form.reset();
  };
  return (
    <div>
      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          className="space-y-8 bg-white shadow-md rounded px-8 pt-6 pb-8 m-4"
        >
          <FormField
            control={form.control}
            name="email"
            defaultValue={""}
            render={({ field }) => {
              return (
                <FormItem className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                  <FormLabel>Your Email</FormLabel>
                  <FormControl>
                    <Input placeholder="name@company.com" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              );
            }}
          />
          <Button variant="default" type="submit">
            Send Reset Password Email
          </Button>
        </form>
      </Form>
    </div>
  );
}
